import { useLocation } from "react-router-dom";
import "./styles.css";

const ErrorPage = () => {
  const location = useLocation();
  let msg:string = location.state?.message || "";
  if (!msg){
    msg = 'Esta URL não existe. Talvez você tenha se equivocado ao digitar o endereço URL.';
  }

  return (
    <div className='main-content pl-3' id='main-content'>
      <div className='template-erro'>
        <div className='row'>
          <div className='col text-center text-sm-left'>
            <div className='text-support-03'>
              <p className='text-up-06 text-semi-bold my-3'>
                ⚠️ Erro
              </p>
            </div>
            <p className='my-3'>
              {msg}
            </p>
            <p className='my-3'>
              Se necessário, relate o erro para que possamos sempre estar melhorando.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
